mutation UpdateEditableGroupValues($editableGroupValues: [InputEditableGroupValue]!) {
    updateEditableGroupValues(editableGroupValues: $editableGroupValues) {
        _id
        value
    }
}
